import React from 'react';
import CodeBlock from '@atlaskit/code/block';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import { CopyAction, ActionContainer } from './code-block-actions/CopyAction.tsx';

type Props = {
	/**
	 * The source code for the code block
	 */
	source: string;
	/**
	 * The action subject ID to use for the UI analytics event fired when the copy button is clicked
	 */
	copyCodeActionSubjectId?: string;
};

/**
 * A code block with a copy action button
 */
export const CodeBlockWithCopyButton = ({
	source,
	copyCodeActionSubjectId,
}: Props): React.JSX.Element => (
	<Box xcss={wrapperStyles} role="region">
		<ActionContainer>
			<CopyAction source={source} actionSubjectId={copyCodeActionSubjectId} />
		</ActionContainer>
		<Box>
			<CodeBlock text={source} showLineNumbers={false} shouldWrapLongLines={false} />
		</Box>
	</Box>
);

const wrapperStyles = xcss({
	width: '100%',
	position: 'relative',
});
